var _path, _path2, _circle;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLocation(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "colored",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 22.5C12.2671 22.5 17.5 14.3269 17.5 10.119C17.5 5.91116 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.91116 2.5 10.119C2.5 14.3269 7.73286 22.5 10 22.5ZM10.9998 12.5C12.5531 12.5 13.8123 11.2208 13.8123 9.64286C13.8123 8.0649 12.5531 6.78571 10.9998 6.78571C9.44652 6.78571 8.18732 8.0649 8.18732 9.64286C8.18732 11.2208 9.44652 12.5 10.9998 12.5Z",
    fill: "#00C1F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 9.5C20.5 13.9183 14.9183 22.5 12.5 22.5C10.0817 22.5 4.5 13.9183 4.5 9.5C4.5 5.08172 8.08172 1.5 12.5 1.5C16.9183 1.5 20.5 5.08172 20.5 9.5Z",
    stroke: "#131416",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 10,
    r: 3,
    stroke: "#131416",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.d824f9a2.svg";
export { ForwardRef as ReactComponent };